<template>
  <div ref="pseudoContainer">
    <!-- This div will be used as the marker element -->
    <div ref="markerElement">
      <slot name="marker"></slot>
      <span v-if="itemsCount > 1" class="item-count">{{ itemsCount }}</span>
    </div>

    <!-- This div will be used as the container for the popup -->
    <div ref="popupContent">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import * as maplibregl from "maplibre-gl";

export default {
  name: "MapMarker",
  inject: ["mapReady"],
  provide() {
    return {
      popupState: this.computedFunction(() => ({
        isOpen: this.isPopupOpen,
      })),
    };
  },
  props: {
    lngLat: {
      type: Array,
      required: true,
    },
    itemsCount: {
      type: Number,
      required: true,
    },
    computedFunction: {
      type: Function,
      required: true,
    },
  },
  emits: ["click"],
  data() {
    return {
      marker: null,
      popup: null,
      isPopupOpen: false,
    };
  },
  mounted() {
    // Wait until the map is ready before adding the marker
    this.mapReady().then((map) => {
      this.$nextTick(() => {
        this.initializeMarker(map);
      });
    });
  },
  unmounted() {
    this.destroyMarker();
  },
  destroyed() {
    this.destroyMarker();
  },
  methods: {
    initializeMarker(map) {
      const coordinates = this.lngLat;
      const markerElement = this.$refs.markerElement;

      if (!markerElement) return;

      // Bind click event and emit it up
      markerElement.addEventListener("click", () => {
        this.$emit("click");
      });

      // Create the marker
      this.marker = new maplibregl.Marker({
        element: markerElement,
        className: "map-marker",
      }).setLngLat(coordinates);

      // If there's popup slot content, create a popup and attach it
      if (this.$refs.popupContent.innerHTML.trim()) {
        this.popup = new maplibregl.Popup({
          offset: [0, -20],
          closeButton: false,
          closeOnMove: false,
          maxWidth: "95%",
          subpixelPositioning: true,
          className: "map-popup",
          trackPointer: false,
          anchor: "bottom",
        }).setDOMContent(this.$refs.popupContent);

        this.popup.on("open", () => {
          this.isPopupOpen = true;
          this.marker.getElement().classList.add("-active");
        });

        this.popup.on("close", () => {
          this.isPopupOpen = false;
          this.marker.getElement().classList.remove("-active");
        });

        this.marker.setPopup(this.popup).addTo(map);
      } else {
        this.marker.addTo(map);
      }
    },
    destroyMarker() {
      if (this.popup) {
        // Remove event listeners before removing the popup
        this.popup.off("open");
        this.popup.off("close");
        this.popup.remove();
      }
      if (this.marker) this.marker.remove();
    },
  },
};
</script>
